module.exports = __webpack_public_path__ + "static/media/view.29eceff3.svg";